import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../store'
import { TrainerServiceTrainer } from '../onDemandWorkouts'
import { TrainerState } from '.'

export const initialState: TrainerState = {
  error: '',
  isLoading: false,
  trainer: {} as TrainerServiceTrainer,
}

export const trainerSlice = createSlice({
  name: 'trainer',
  initialState,
  reducers: {
    getTrainerPending: (
      state: TrainerState,
      action: PayloadAction<boolean>,
    ) => {
      state.isLoading = action.payload
      state.trainer = initialState.trainer
    },
    getTrainerSuccess: (
      state: TrainerState,
      action: PayloadAction<TrainerServiceTrainer>,
    ) => {
      state.error = initialState.error
      state.isLoading = initialState.isLoading
      state.trainer = action.payload
    },
    getTrainerFailure: (
      state: TrainerState,
      action: PayloadAction<TrainerState['error']>,
    ) => {
      state.error = action.payload
      state.isLoading = initialState.isLoading
      state.trainer = initialState.trainer
    },
    trainerReset: () => initialState,
  },
})

export const {
  getTrainerPending,
  getTrainerSuccess,
  getTrainerFailure,
  trainerReset,
} = trainerSlice.actions

export const trainerSelector = (state: RootState) => state.trainer

export default trainerSlice.reducer
